import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByAppSolidSize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M27.631 18.06a2.977 2.977 0 0 1 2.969 2.97A2.98 2.98 0 0 1 27.63 24h-8.91v-5.94z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.696 2c6.406 0 9.611 0 12.058 1.246a11.44 11.44 0 0 1 5 5C46.001 10.693 46 13.898 46 20.305v7.39c0 6.407.001 9.612-1.246 12.059a11.44 11.44 0 0 1-5 5C37.307 46 34.103 46 27.696 46h-7.391c-6.407 0-9.611 0-12.059-1.246a11.44 11.44 0 0 1-5-5C2 37.307 2 34.102 2 27.695v-7.39c0-6.407 0-9.612 1.246-12.059a11.44 11.44 0 0 1 5-5C10.694 1.999 13.898 2 20.305 2zM12.56 36.1h6.16v-5.94h7.385l4.054 5.94h6.6l-4.809-7.024a9.16 9.16 0 0 0 4.809-8.047 9.1 9.1 0 0 0-.693-3.494 9.1 9.1 0 0 0-1.98-2.96 9.1 9.1 0 0 0-2.962-1.981 9.1 9.1 0 0 0-3.494-.694h-15.07z"
            fill="currentColor"
        />
    </svg>
));
RabotaByAppSolidSize48Glyph.displayName = 'RabotaByAppSolidSize48Glyph';
